class CartCount extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.clearGiftMessage()
  }

  setupListeners () {
    super.setupListeners()

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )
  }

  clearGiftMessage () {
    const currentCount = parseInt(this.dataset.currentCount)

    if (currentCount > 0) return

    window.BAO.Cart.updateAttributes({
      'Gift message': '',
    })
  }

  /**
   * @param {CustomEvent} e
   *
   * @returns {void}
   */
  onCartChanged (e) {
    const { state } = e.detail
    if (!state) return
    if (!state.sections) return

    if (!('push-cart-count' in state.sections)) return

    const count = this.getCount(state.sections['push-cart-count'])
    this.textContent = count

    const action = count.length >= 3 ? 'add' : 'remove'
    this.classList[action]('hd-Banner_CartCount-large')

    this.setAttribute('aria-hidden', Number(this.textContent) === 0)
  }

  /**
   * @param {string} html
   *
   * @returns {string}
   */
  getCount (html) {
    const DOM = window.BAO.sectionRenderer.convertToDOM(html)

    return DOM.querySelector('#push-cart-count').textContent
  }
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount)
}
